export default [
  {
    path: '/anexar',
    name: 'anexar',
    component: () => import(/* webpackChunkName: "anexar" */ './Anexar.vue')
  }
]
